module.exports = __webpack_public_path__ + "img/sleeve_cap.e6b4c112.png";